import {postApi, deleteApi, setHeaderUser, OK, setSessionId} from '@/util'

var tokenWait = true
const tokenWaitTime = 5000

const state = {
	apiStatus: null,
	userData: null,
	loginErrorMessages: null,
	reLoginErrorMessages: null,
	token: "",
	is_auto_login: true,
	signupParam: null,
}

const mutations = {
	setApiStatus (state, status) {
		state.apiStatus = status
	},
	setUserData (state, userData) {
		state.userData = userData
	},
	setLoginErrorMessages (state, messages) {
		state.loginErrorMessages = messages
	},
	setReLoginErrorMessages (state, messages) {
		state.reLoginErrorMessages = messages
	},
	updatePushToken(state, token) {
		state.token = token
	},
	setIsAutoLogin(state, flag) {
		state.is_auto_login = flag
	},
	setSignUpParam(state, data) {
		state.signupParam = data
	}
}

const actions = {
	// ログイン
	async loginApi (context, data) {
		context.commit('setApiStatus', null)
		const response = await postApi('authorize', data)

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setUserData', JSON.parse(response.data))
			context.commit('setIsAutoLogin', true)
			setHeaderUser(JSON.parse(response.data).trn_user_id)
			setSessionId(JSON.parse(response.data).session_id)
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	// ログアウト
	async logoutApi (context) {
		context.commit('setApiStatus', null)
		const response = await deleteApi('authorize')

		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setUserData', null)
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	// 再ログイン
	async reloginApi (context, data) {
		context.commit('setApiStatus', null)
		const response = await postApi('relogin', data)

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setUserData', JSON.parse(response.data))
			context.commit('setIsAutoLogin', true)
			setHeaderUser(JSON.parse(response.data).trn_user_id)
			setSessionId(JSON.parse(response.data).session_id)
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	// 認証コード発行
	async resetApi (context, data) {
		context.commit('setApiStatus', null)
		const response = await postApi('password_reset', data)
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			return false
		}
		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	// 再設定
	async reregistApi (context, data) {
		context.commit('setApiStatus', null)
		const response = await postApi('password_reregist', data)
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			return false
		}
		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', '認証コードが一致しません。', { root: true })
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
